import { Box, CardMedia, Grid, IconButton, Typography, useTheme } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';

import { Redirect, Route, Router, Switch, useHistory, useRouteMatch } from 'react-router';
import EnterOTP from './enterOTP';
import EnterPAN, { EnterEmailId, EnterMobile } from './enterPAN';
import { CommonLayout } from '../commonComponents';
import { Location } from 'history';
import { ApplicationProps } from '../../redux-store/types/api-types';
import { DocumentsVerification } from './documentVerification';
import { APPLICATION_TYPE, USER_ROLES } from '../../utils/constant';
import { useSelector } from 'react-redux';
import { RootStateType } from '../../redux-store/reducers';
import BreadCrum from '../../lib/BreadCrum';
import { isModuleAllowed } from '../../utils/utilityFunctions';

const routerList = [
  {
    name: 'Enter PAN Number',
    path: 'enter-pan-number',
    component: EnterPAN,
  },
  {
    name: 'Enter Mobile Number',
    path: 'enter-mobile-number',
    component: EnterMobile,
  },
  {
    name: 'Enter OTP',
    path: 'enter-otp',
    component: EnterOTP,
  },
  {
    name: 'Enter Email Id',
    path: 'enter-email-id',
    component: EnterEmailId,
  },
  {
    name: 'Verify Documents',
    path: 'verify-documents',
    component: DocumentsVerification,
  }
]

function Routes(): JSX.Element {
  const history = useHistory();
  const { path } = useRouteMatch();
  return (
    <Router history={history}>
      <Switch>
        <Route
          exact
          path={path}
          render={() => <Redirect to={`${path}/enter-pan-number`} from={location.pathname} />}
        />
        {routerList.map((item, index) => (
          <Route
            key={index}
            path={`${path}/${item.path}`}
            component={item.component}
          />
        ))}
        {/* <Route path={`${path}/enter-pan-number`} component={EnterPAN} />
        <Route path={`${path}/enter-mobile-number`} component={EnterMobile} />
        <Route path={`${path}/enter-otp`} component={EnterOTP} />
        <Route path={`${path}/enter-email-id`} component={EnterEmailId} />
        <Route path={`${path}/verify-documents`} component={DocumentsVerification} /> */}
      </Switch>
    </Router>
  );
}

//Router
// Onboard Investor Layout
function OnBoarding({ routerPath, id, firstHolderName, path }: { routerPath: any, id?: string, firstHolderName?: string, path: string }): JSX.Element {
  const theme = useTheme();
  const history = useHistory();
  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <BreadCrum array={routerPath} />
        {/* <IconButton
            //  onClick={() => history.push('/')}
            sx={{
              // height: 'fit-content', 
              height: "18px",
              p: 0,
            }}
            component={RouterLink}
            to={
              [USER_ROLES.AMCAPPROVER, USER_ROLES.POAAPPROVER].includes(role)
                ? '/applications-list'
                : '/applications'
            }>
            <NavigateBeforeIcon fontSize="small" sx={{ color: 'text.secondary' }} />
          </IconButton> */}
        {/* <Typography
            variant='subtitle_500'
            // sx={{ fontSize: 20, fontWeight: 600, color: 'primary.main' }}
            color="text.secondary"
          >
            {id
              ? 'Add Joint Holder'
              : application?.applicationType === APPLICATION_TYPE.NON_INDIVIDUAL
                ? 'Onboard Non Individual Investor'
                : history.location.pathname === `${path}/enter-otp`
                  ? 'OTP'
                  : 'Onboard Investor'}
          </Typography> */}
      </Box>
      <Box mb="25px" mt={2}>
        <Typography variant='h1' color="text.primary">
          {id ? 'Add Joint Holder' : 'Onboard Investor'}
        </Typography>
      </Box>
      <Box
        sx={{
          p: "25px",
          bgcolor: "background.paper",
          boxShadow: `0px 4px 10px 0px ${theme.palette.common.black}0D`,
          borderRadius: '25px',
          minHeight: { xs: 'calc(100vh - 100px)', md: 'calc(100vh - 195px)' },
          display: "flex",
          alignItems: "stretch",
        }}>
        {history.location.pathname === `${path}/verify-documents` ? (
          <Routes />
        ) : (
          <>
            {/* {id && (
                <Typography
                  sx={{
                    ml: 3,
                    fontSize: 20,
                    color: "common.black",
                    fontWeight: 500,
                  }}>
                  Please provide joint holder details{' '}
                  {firstHolderName !== 'N/A' && `- ${firstHolderName}`}
                </Typography>
              )} */}
            <Grid container sx={{ mt: id ? 1 : 0 }} rowGap={2}>
              <Grid
                item
                container
                xs={12}
                lg={6}
                sx={{ alignSelf: 'center', display: { xs: 'none', lg: 'flex' } }}
              >
                <Grid
                  item xs={3}
                />
                <Grid
                  item
                  xs={6}
                >
                  <CardMedia
                    component="img"
                    src="/images/onboard-investor.svg"
                    alt="Illustration"
                    width="203px"
                    height="203px"
                    sx={{ objectFit: "contain" }}
                  />
                  <Typography
                    variant='h1'
                    component="h2"
                    color="text.primary"
                    textAlign="center"
                    py={1}
                  >
                    {id ? `Please provide joint holder details ${firstHolderName !== 'N/A' ? ` - ${firstHolderName}` : ""}` : "Onboard New Investor"}
                  </Typography>
                  <Typography
                    variant='subtitle_400'
                    color="text.secondary"
                    textAlign="center"
                  >
                    Offer essential information to facilitate the seamless onboarding of the investor.
                  </Typography>
                </Grid>
                <Grid
                  item xs={3}
                />
              </Grid>
              <Grid
                item
                container
                xs={12}
                lg={6}
                border={`1px solid ${theme.palette.text.secondary}26`}
                borderRadius="15px"
                p="35px"
              >
                <Grid item xs={12}>
                  <Routes />
                </Grid>
              </Grid>
            </Grid>
          </>
        )}
      </Box >
    </>
  );
}


export default function OnboardInvestorLayout({
  location,
}: {
  location: Location<{ application: ApplicationProps; firstHolderName: string }>;
}): JSX.Element {
  const theme = useTheme()

  const { application, firstHolderName = '' } = location.state || {};
  const { id } = application || {};
  const history = useHistory();
  const { path } = useRouteMatch();
  const { role = '', permissions = [] } = useSelector((store: RootStateType) => store.auth);

  const initialRouter = history.location.pathname?.split('/').filter((item) => item !== '')

  // const routerText = initialRouter[1]?.split('-').join(' ')

  const routerPath = initialRouter[0] === 'onboarding'
    ?
    [
      {
        name: 'Dashboard',
        path: '/dashboard',
        warning: true
      },
      {
        name: 'Onboarding investor',
        path: `/${initialRouter[0]}`,
      },
    ]
    :
    [
      {
        name: 'Dashboard',
        path: '/dashboard',
        warning: true
      },
      {
        name: 'Onboarding investor',
        path: `/${initialRouter[0]}`,
      },
      {
        name: initialRouter[1]?.split('-').join(' '),
        path: `/${initialRouter[0]}/${initialRouter[1]}`,
      },
    ]


  // console.log('location', initialRouter[1].split('-').join(' ').toLocaleUpperCase())
  return USER_ROLES.AMCAPPROVER === role ? (
    <>
      {/* <CommonLayoutForPOA > */}
      <CommonLayout>
        <Box sx={{ py: 3, px: { xs: 2, sm: 10 }, mt: 10 }}>
          <OnBoarding
            id={id}
            firstHolderName={firstHolderName}
            routerPath={isModuleAllowed({ value: "MFDashboard", compareArr: permissions, objKey: "permissonCode" }) ? routerPath : []}
            path={path}
          />
        </Box>
        {/* </CommonLayoutForPOA> */}
      </CommonLayout>
    </>
  ) : (
    <CommonLayout>
      <OnBoarding
        id={id}
        firstHolderName={firstHolderName}
        routerPath={isModuleAllowed({ value: "MFDashboard", compareArr: permissions, objKey: "permissonCode" }) ? routerPath : []}
        path={path}
      />
    </CommonLayout>
  );
}
